<template>
  <div>
    <recharge tokenType="diamond">
      <p class="line-title">{{$t('upgrade_page_views_diamond_recharge_index_417')}}</p>
      <div class="exchange-diamond" @click="showDiamondDialog()">
        <div class="left">
          <img src="~@/assets/image/icons/diamond.png" />
          <span>{{$t('upgrade_page_views_diamond_recharge_index_418')}}</span>
        </div>
        <span class="send-gold">1:15</span>
      </div>
    </recharge>
    <diamond-dialog
      ref="diamondDialog"
      :accountInfo="accountInfo"
      :userInfo="userInfo"
    ></diamond-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DiamondDialog from './diamond-dialog.vue';
import Recharge from '@/components/Recharge/index.vue';

export default {
  components: {
    Recharge,
    DiamondDialog
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo']),

    uuid() {
      return this.userInfo && this.userInfo.uuid ? this.userInfo.uuid : null;
    }
  },

  methods: {
    showDiamondDialog() {
      this.$refs.diamondDialog.showPayDialog();
    }
  }
};
</script>

<style lang="scss" scoped>
.exchange-diamond {
  border-radius: 4px;
  color: #222c43;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid #e8eaee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 170px;
  height: 62px;
  padding: 0 16px;
  margin-bottom: 42px;
  img {
    height: 22px;
    width: 22px;
    margin-right: 4px;
  }
  .left {
    display: flex;
    align-items: center;
  }
}
</style>
